export default __webpack_public_path__ + "static/media/cow.61baee75.png";